import React from 'react';
import Card from 'components_v2/common/CardV2';
import AdCaller from 'helpers/ads/adCaller';
import Listingheader from 'routes/home/components/common/ListingheaderV2';
import { VIEW_ALL } from 'constants/index';
import s from './PhotoVideoTile.scss';

function PhotoVideoTile(props) {
  const {
    topicData,
    isPhotosTile,
    headingName,
    hidePhotoMoreButton,
    hideVideoMoreButton,
    viewVideos,
    viewPhotos,
    loadMorePhotos,
    loadMoreVideos,
    isLoadingVideoData,
    isLoadingPhotoData,
    selectedTab,
    isPrime,
    getLeaderboardAds = () => {},
    viewAll,
    widgetName,
    isNoLink,
    noLinkClass,
  } = props;

  return topicData && Array.isArray(topicData) && topicData.length > 0 ? (
    <div
      className={`${s.photos_section} ${
        s.tabs_section
      } tabs_common photos_videos`}
    >
      {headingName && (
        <Listingheader
          headingname={headingName}
          overrideClass={s.topicheading}
        />
      )}
      {isPhotosTile ? (
        <div>
          <div className={s.common_block}>
            {/* {isLoadingPhoto && (
              <div className={s.loaderouter}>
                <LoaderSpinner />
              </div>
            )} */}
            {topicData.map((data, index) => {
              const leaderboardAd = getLeaderboardAds(index, selectedTab);
              return (
                <>
                  <div className={s.common_col}>
                    <Card
                      //isLeadTypeTwo
                      showDescription={false}
                      data={data}
                      itemClass={
                        data.wu &&
                        data.wu.includes('timesofindia.indiatimes.com')
                          ? 'linktype2 photoCard photoStoryCard'
                          : 'linktype2 photoCard photoGalCard'
                      }
                      isVerticalTile
                      imgWidth="200"
                      newga={`Search_Result-${selectedTab}#View_Content-Open_Content-${index +
                        1}`}
                      topicPage
                      shouldNotlazyloadImage={
                        selectedTab === 'All' ? false : !(index > 4)
                      }
                      isNoLink={isNoLink}
                      noLinkClass={noLinkClass}
                    />
                  </div>
                  {!isPrime &&
                    leaderboardAd &&
                    (index + 1) % 20 === 0 && (
                      <div className="leaderboardAd">
                        <div className="lbAdplaceholder">
                          <AdCaller
                            data={leaderboardAd}
                            immediateLoad
                            skipReRender
                          />
                        </div>
                      </div>
                    )}
                </>
              );
            })}
          </div>
          {typeof viewPhotos === 'function' && (
            <div className={`${s.loadMore}`}>
              <button type="button" onClick={() => viewPhotos(true)}>
                {VIEW_ALL}
              </button>
            </div>
          )}
          {typeof loadMorePhotos === 'function' &&
            !hidePhotoMoreButton && (
              <div
                className={`${s.loadMore} ${
                  isLoadingPhotoData ? s.loader : ''
                }`}
              >
                <button type="button" onClick={loadMorePhotos}>
                  Load More
                </button>
              </div>
            )}
        </div>
      ) : (
        <div>
          {/* {isLoadingVideo && (
            <div className={s.loaderouter}>
              <LoaderSpinner />
            </div>
          )} */}
          <div className={s.common_block}>
            {topicData.map((data, index) => {
              const leaderboardAd = getLeaderboardAds(index, selectedTab);
              return (
                <>
                  <div className={s.common_col}>
                    <Card
                      data={data}
                      itemClass="linktype2 videocard"
                      isVerticalTile
                      imgWidth="200"
                      newga={`Search_Result-${selectedTab}#View_Content-Open_Content-${index +
                        1}`}
                      topicPage
                      isNoLink={isNoLink}
                      noLinkClass={noLinkClass}
                    />
                  </div>
                  {!isPrime &&
                    leaderboardAd &&
                    (index + 1) % 20 === 0 && (
                      <div className="leaderboardAd">
                        <div className="lbAdplaceholder">
                          <AdCaller
                            data={leaderboardAd}
                            immediateLoad
                            skipReRender
                          />
                        </div>
                      </div>
                    )}
                </>
              );
            })}
          </div>
          {typeof viewVideos === 'function' && (
            <div className={`${s.loadMore}`}>
              <button type="button" onClick={() => viewVideos(true)}>
                {VIEW_ALL}
              </button>
            </div>
          )}
          {typeof loadMoreVideos === 'function' &&
            !hideVideoMoreButton && (
              <div
                className={`${s.loadMore} ${
                  isLoadingVideoData ? s.loader : ''
                }`}
              >
                <button type="button" onClick={loadMoreVideos}>
                  Load More
                </button>
              </div>
            )}
          {typeof viewAll === 'function' && (
            <div className={`${s.loadMore}`}>
              <button type="button" onClick={() => viewAll(widgetName)}>
                {VIEW_ALL}
              </button>
            </div>
          )}
        </div>
      )}

      {/* <div className={`${s.loadMore}`}>
        <button type="button">View All</button>
      </div> */}
    </div>
  ) : null;
}

export default PhotoVideoTile;
